export default class EventEmitter {
    constructor(subscriptions = [], options = {}) {
        this.subscriptions = subscriptions;
        this.options = options;

        this._subscriptions = new Map();

        this.init();
    }

    init() {
        this.subscriptions.forEach((subscription) => {
            this.subscribe(subscription.event, subscription.callback);
        });
    }

    dispatch(event, data) {
        this._subscriptions.forEach((subscription) => {
            if (subscription.event === event) {
                subscription.callback(data);
            }
        });
    }

    subscribe(event, callback) {
        const id = Symbol();
        const subscription = new EventSubscription({ id, event, callback,
            unsubscribe: () => {
                this._subscriptions.delete(id);
            }
        });

        this._subscriptions.set(id, subscription);

        return subscription;
    }

    addSubscriptions(subscriptions) {
        return subscriptions.map((subscription) => this.subscribe(subscription.event, subscription.callback));
    }

    unsubscribe(event) {
        this._subscriptions.forEach((subscription) => {
            if (subscription.event === event) {
                subscription.unsubscribe();
            }
        });
    }

    unsubscribeAll() {
        this._subscriptions.forEach((subscription) => {
            subscription.unsubscribe();
        });
    }
}

export class EventSubscription {
    constructor({ id, event, callback, unsubscribe }) {
        this.id = id;
        this.event = event;
        this.callback = callback;
        this.unsubscribe = unsubscribe;
    }
}